import React from 'react';
import LedgerDatasetTableShell, { LedgerDatasetTableShellProps } from '../shared/LedgerDatasetTableShell';

type InventoryItemsTableProps = Omit<LedgerDatasetTableShellProps, 'view' | 'accountingSource'>;

const InventoryItemsTable: React.FC<InventoryItemsTableProps> = (props) => (
    <LedgerDatasetTableShell {...props} view="inventory" accountingSource="uploaded_bills" />
);

export default InventoryItemsTable;
